import React from "react";

import { ReactComponent as IconClose } from "../../../../build/images/attendanceIcons/close-side-info.svg";

import "./header-faq-dragable.styles.css";
import { useHeader } from "./hooks/useHeader";

const Header = () => {
  const { handleClose } = useHeader();
  return (
    <header className="header-faq-dragable">
      <h1>Ajuda</h1>
      <button onClick={handleClose}>
        <IconClose />
      </button>
    </header>
  );
};

export default Header;
